"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageEmbed = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useWindowSize_1 = __importDefault(require("../hooks/useWindowSize"));
function ImageEmbed({ id, customId, imageUrl, imageUrlMobile, imageAltText, imgSize, linkUrl, linkTarget, backgroundColor, imagePlacement, linkClassName, linkProps, }) {
    const { isMobile } = (0, useWindowSize_1.default)();
    const placementClasses = imagePlacement === 'Left'
        ? 'justify-start'
        : imagePlacement === 'Right'
            ? 'justify-end'
            : 'justify-center';
    const sizeClasses = imgSize === 'Small'
        ? 'sm:max-w-[45%] md:max-w-[30%]'
        : imgSize === 'Medium'
            ? 'md:max-w-[45%] lg:max-w-[55%]'
            : imgSize === 'Large'
                ? 'xl:max-w-[80%]'
                : '';
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('w-full my-8', { 'py-6': backgroundColor }, isMobile, imageUrl, imageUrlMobile), style: { backgroundColor: backgroundColor } },
        react_1.default.createElement("div", { id: customId, className: (0, classnames_1.default)('max-w-screen-2xl flex mx-auto px-4', placementClasses) }, linkUrl ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("a", Object.assign({ href: linkUrl, target: linkTarget, rel: linkTarget === '_blank' ? 'noreferrer' : '', className: (0, classnames_1.default)('max-w-screen-2xl', sizeClasses, linkClassName) }, linkProps),
                react_1.default.createElement("img", { src: isMobile && imageUrlMobile ? imageUrlMobile : imageUrl, alt: imageAltText, className: (0, classnames_1.default)('max-w-full') })))) : (react_1.default.createElement("img", { src: isMobile && imageUrlMobile ? imageUrlMobile : imageUrl, alt: imageAltText, className: (0, classnames_1.default)('max-w-full', sizeClasses) })))));
}
exports.ImageEmbed = ImageEmbed;
